// Hooks / Node modules / Styles
import { motion } from "framer-motion";

// Reducers / Actions

// Utils / Functions
import { textVariant, fadeIn } from "src/utils/framer-motion/motion";

// Components

// Sub-Components

// Data / Images / Icons

function ComponentContainer({ title, subtitle, description, children }) {
  return (
    <div className="py-16 select-none">
      {/* Introduction and Overview */}
      <motion.div variants={textVariant()}>
        <p className="text-center text-lg local-theme-text-sm">{subtitle}</p>
        <h2 className="text-center text-4xl font-semibold local-theme-text-md mt-4">
          {title}
        </h2>
      </motion.div>

      {description && (
        <motion.p
          variants={fadeIn("", "", 0.1, 1)}
          className="mt-6 text-center local-theme-text-xs text-lg max-w-3xl mx-auto leading-[30px]"
        >
          {description}
        </motion.p>
      )}

      <div>{children}</div>
    </div>
  );
}

export default ComponentContainer;
